export enum DialogTrainingState {
  LoopNet,
  Crexi,
  None,
}
